/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Horario.vue?vue&type=template&id=1f93406f&"
import script from "./Horario.vue?vue&type=script&lang=js&"
export * from "./Horario.vue?vue&type=script&lang=js&"
import style0 from "./Horario.vue?vue&type=style&index=0&id=1f93406f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports